import React from 'react';


export default function MenuIcon() {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.5 27H28.5M16.5 18H28.5M7.5 9H28.5" stroke="currentColor"/>
</svg>

  )
}
